import { render, staticRenderFns } from "./FullScreenFile.vue?vue&type=template&id=1763e67b&scoped=true"
import script from "./FullScreenFile.vue?vue&type=script&lang=js"
export * from "./FullScreenFile.vue?vue&type=script&lang=js"
import style0 from "./FullScreenFile.vue?vue&type=style&index=0&id=1763e67b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763e67b",
  null
  
)

export default component.exports